import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export const Calendar = React.forwardRef(({ 
  className = '', 
  classNames = {},
  showOutsideDays = true,
  ...props 
}, ref) => {
  return (
    <div className={`p-3 ${className}`} {...props}>
      <div className="space-y-4">
        <div className="relative">
          <div className="flex items-center justify-between">
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900 h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
            >
              <ChevronLeftIcon className="h-4 w-4" />
            </button>
            <div className="text-sm font-medium">
              Janvier 2024
            </div>
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900 h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
            >
              <ChevronRightIcon className="h-4 w-4" />
            </button>
          </div>
        </div>
        <table className="w-full border-collapse space-y-1">
          <thead>
            <tr className="flex">
              {['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'].map((day) => (
                <th
                  key={day}
                  className="text-slate-500 rounded-md w-9 font-normal text-[0.8rem]"
                >
                  {day}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="space-y-1">
            {/* Exemple de semaine */}
            <tr className="flex w-full mt-2">
              {[1, 2, 3, 4, 5, 6, 7].map((day) => (
                <td key={day} className="h-9 w-9 text-center text-sm p-0 relative">
                  <button
                    type="button"
                    className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-slate-100 hover:text-slate-900 h-9 w-9 p-0 font-normal aria-selected:opacity-100"
                  >
                    {day}
                  </button>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
});

Calendar.displayName = 'Calendar';
